import React from "react";
import PropTypes from "prop-types";
// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import DashboardTabs from "components/CustomTabs/DashboardTabs.jsx";
import Card from "components/Card/Card.jsx";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";

import httpr from "lib/httpRequest";
import { BASE_URL } from "lib/config";

class Dashboard extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      value: 0,
      tabs: [],
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.getOrganizations();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getOrganizations() {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    return new Promise(async (resolve, reject) => {
      fetch
        .get(`${BASE_URL}/api/organization`)
        .then((response) => {
          const organizations = response.data.filter(
            (org) => org.OrganizationId !== 0
          );

          const tabs = organizations.map((org) => {
            return {
              tabName: `${org.OrganizationName}`,
              dataUrl: `/api/location/organization/${org.OrganizationId}`,
              organizationId: org.OrganizationId,
              tabContent: <div />,
            };
          });

          if (this._isMounted === true) {
            this.setState({
              tabs: tabs,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = (index) => {
    this.setState({ value: index });
  };

  render() {
    return (
      <GridContainer>
        <Card>
          <GridItem xs={12} sm={12} md={12}>
            <DashboardTabs
              key={this.state.value}
              title="Organizations:"
              subtitle="Locations:"
              headerColor="scmain"
              tabs={this.state.tabs}
              canSubTabs={true}
              editMember={this.editMember}
              deleteMember={this.deleteMember}
            />
          </GridItem>
        </Card>
      </GridContainer>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(dashboardStyle)(Dashboard);

/*<Redirect to='/login' />*/



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx